// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fp_k","footer":"styles_footer__2fEbZ","passCodeTooltip":"styles_passCodeTooltip__2ShTA"};